define('views/modules/feedback/modal/feedback-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    'services/i18n',
    // views
    'views/parts/modal/modal',
    'views/modules/feedback/modal/feedback-modal-form'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // views
    VModal,
    VFeedbackModalForm
) {

    var VFeedbackModal = VModal.extend({
        modal: {
            className: 'feedback-modal',
            backdrop: true,
            closeButton: false,
        },
        buttons: function(buttons) {
            return _.extend(buttons, {
                confirm: {
                    label: i18n.t("Save my feedback"),
                    callback: this.onConfirm
                },
            });
        },
        initialize: function(opt) {
            opt = opt || {};

            var model = this.model,
                view = this.view = {
                    form: new VFeedbackModalForm({
                        model: model
                    }),
                };

            this.listenTo(view.form, { "form:success": this.onSuccess });
        },

        render: function() {
            this.$el.empty()
                .append(this.view.form.render().el);

            return this.renderModal();
        },

        resetModel: function(model) {
            this.model.reset(model.attributes);
            return this;
        },

        ////////////
        // events //
        ////////////
        onConfirm: function(confirmed) {
            if (confirmed) {
                this.view.form.submit();
                return false;
            }
        },

        onSuccess: function() {
            this.close();
        },

    });

    return VFeedbackModal;

});

